import { useMutation, useQuery } from '@tanstack/react-query';
import USERS_KEYS from '../users.keys';
import USERS_MUTATIONS from '../users.mutations';
import USERS_QUERIES from '../users.queries';

export const useFetchImpersonationUsers = ({ page, pageSize, search, ordering } = {}) =>
  useQuery({
    queryKey: USERS_KEYS.IMPERSONATION_USERS({ page, pageSize, search, ordering }),
    queryFn: () => USERS_QUERIES.FETCH_IMPERSONATION_USERS({ page, pageSize, search, ordering }),
    staleTime: 1 * 60 * 1000,
  });

export const useStartImpersonation = () =>
  useMutation({
    mutationFn: USERS_MUTATIONS.IMPERSONATE_USER,
    onSuccess: () => {
      window.location.href = '/';
    },
  });

export const useExitImpersonation = () =>
  useMutation({
    mutationFn: USERS_MUTATIONS.EXIT_IMPERSONATION,
    onSuccess: () => {
      window.location.href = '/super-user/impersonation';
    },
  });

export const useFetchUsersSuperUserPaginated = ({
  page,
  pageSize,
  search,
  ordering,
  ...filters
} = {}) =>
  useQuery({
    queryKey: USERS_KEYS.USERS_SUPER_USER_PAGINATED({
      page,
      pageSize,
      search,
      ordering,
      ...filters,
    }),
    queryFn: () =>
      USERS_QUERIES.FETCH_USERS_SUPER_USER_PAGINATED({
        page,
        pageSize,
        search,
        ordering,
        ...filters,
      }),
    staleTime: 1 * 60 * 1000,
  });
